import { giphyBlack, giphyDarkestGrey, giphyWhite, giphyDarkGrey } from '@giphy/js-brand'
import React from 'react'
import { BORDER_RADIUS_LARGE, BORDER_RADIUS_MEDIUM } from 'site/creation-tools/constants'
import styled from 'styled-components'

const Container = styled.div`
    background: ${giphyDarkestGrey};
    border-radius: ${BORDER_RADIUS_LARGE}px;
    margin-bottom: 10px;
`

const OpenCloseIcon = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: ${BORDER_RADIUS_MEDIUM}px;
    height: 32px;
    width: 32px;
    background: ${giphyBlack};
    margin: 4px;
    margin-left: 6px;
    cursor: pointer;

    span {
        color: ${giphyWhite};
        margin-bottom: -4px;
    }
`

const Header = styled.div`
    display: flex;
    background: ${giphyDarkGrey};
    border-radius: ${BORDER_RADIUS_LARGE}px;
`

const HeaderContent = styled.div`
    width: 100%;
`

const Content = styled.div``

type CollapseProps = {
    header: React.ReactNode
    children: React.ReactNode
    isOpened: boolean
    onChange: () => void
}

const Collapse = (props: CollapseProps) => {
    const { header, children, isOpened, onChange } = props

    return (
        <Container>
            <Header>
                <HeaderContent>{header}</HeaderContent>
                <OpenCloseIcon onClick={onChange}>
                    {isOpened ? <span className="ss-navigateup" /> : <span className="ss-navigatedown" />}
                </OpenCloseIcon>
            </Header>
            {isOpened && <Content>{children}</Content>}
        </Container>
    )
}

export default Collapse
